import styles from './styles.module.scss';
import { Grow } from '@mui/material';
import {
  ResendCodeButton,
  ValidateCodeInput,
} from '@starsoft/common/components';
import { ConfirmationCodeProps } from '../props';

/**
 * ConfirmationCodeContent component that displays a code validation input with resend button
 *
 * @component
 * @param {Object} props - Component props
 * @param {(code: string) => void} props.handleChangeCode - Callback when code input changes
 * @param {() => void} props.handleSendSms - Callback to resend verification code
 * @param {boolean} props.isLoadingValidationCode - Whether validation is in progress
 * @param {boolean} props.isSuccess - Whether code validation was successful
 * @returns {JSX.Element} Code validation input with resend button in a grow animation
 */
export default function ConfirmationCodeContent({
  handleChangeCode,
  handleSendSms,
  isLoadingValidationCode,
  isSuccess,
}: Omit<ConfirmationCodeProps, 'label'>) {
  return (
    <div className={styles.container}>
      <Grow in={true} timeout={500}>
        <div className={styles.container__wrapper}>
          <ResendCodeButton
            onClick={handleSendSms}
            isLoading={isLoadingValidationCode}
            isSuccess={isSuccess}
          />
          <ValidateCodeInput setValue={handleChangeCode} />
        </div>
      </Grow>
    </div>
  );
}
